import React, { useCallback, useEffect, useMemo } from 'react'

import { Route, Switch } from 'react-router-dom'
import { batch, useDispatch, useSelector } from 'react-redux'

import SeafarersList from '../../components/SeafarersList/SeafarersList'
import SearchTabsPanel from '../../components/SearchTabsPanel/SearchTabsPanel'
import SeafarersSearchSort from '../../components/SeafarersSearchSort/SeafarersSearchSort'
import SeafarerCard from './SeafarerCard'
import SeafarersSearchPanel from '../../components/SeafarersSearchPanel/SeafarersSearchPanel'
import SearchFilterForm from '../../components/SeafarersSearchPanel/FilterForm/SearchFilterForm/SearchFilterForm'
import WithPreloader from '../../HOC/WithPreloader'

import {
  clearCommentsData,
  clearSeafarersList,
  setSeafarersList,
  updateSearchFilterOptions,
} from '../../redux/actions/seafarersSearch'
import { fetchSeafarersList } from '../../api/getApi'
import { fetchSeafarersHelper, objToQueryConverter } from '../../helpers/apiHelper'
import useInfiniteScroll from '../../hooks/useInfiniteScroll'
import { searchHelper } from '../../components/SeafarersSearchPanel/utils'
import { profilePaths } from '../../constants/constants'

const Search = () => {
  const { list, filter } = useSelector(({ seafarersSearch }) => seafarersSearch)

  const dispatch = useDispatch()

  useEffect(() => {
    return () => {
      batch(() => {
        dispatch(clearCommentsData())
        dispatch(clearSeafarersList())
      })
    }

    // eslint-disable-next-line
  }, [])

  const values = useMemo(() => {
    return searchHelper(filter)
  }, [filter])

  const { loading, nextPage, handleScroll } = useInfiniteScroll(
    fetchSeafarersList,
    setSeafarersList,
    fetchSeafarersHelper,
    objToQueryConverter(values),
    clearSeafarersList
  )

  const handleListScroll = (e) => {
    handleScroll(e)
  }

  const handleSortChange = useCallback((value, status) => {
    if (!value) return

    const separator = (() => {
      if (status) return ''

      return '-'
    })()

    const ordering = `${separator}${value}`

    dispatch(updateSearchFilterOptions({ ordering }))

    // eslint-disable-next-line
  }, [])

  return (
    <>
      <SeafarersSearchPanel Form={SearchFilterForm} searchValues={filter} updateAction={updateSearchFilterOptions} />

      <div className="space-between align-item-center min-height-50">
        <SearchTabsPanel route={profilePaths.seafarers_search} />

        <div style={{ width: '100%', maxWidth: '260px' }}>
          <SeafarersSearchSort onChange={handleSortChange} />
        </div>
      </div>

      <Switch>
        <Route exact path={profilePaths.seafarers_search}>
          <WithPreloader
            size={150}
            type="magnifier"
            noContentMessage="Sorry, there are no results for this search."
            tab="search"
            list={list}
            component={SeafarersList}
            isLoading={nextPage ? loading : null}
            isActive={nextPage === 1 && loading}
            onScroll={handleListScroll}
            // isFilterOpen={isFilterOpen}
            // onWheel={(e) => (e.deltaY > 0 ? setIsMouseUp(false) : setIsMouseUp(true))}
          />
        </Route>

        <Route exact path={`${profilePaths.seafarers_search}/:id`} component={SeafarerCard} />
      </Switch>
    </>
  )
}

export default Search
